import { createContext } from 'react'

const ModuleNavContext = createContext()
ModuleNavContext.displayName = 'ModuleNavContext'

const ModuleNavProvider = ({ navbar, setNavbar, children }) => {
    return (
        <ModuleNavContext.Provider value={{ navbar, setNavbar }}>
            {children}
        </ModuleNavContext.Provider>
    )
}

export { ModuleNavContext, ModuleNavProvider }
